import { compose } from "@reduxjs/toolkit";
import React from "react";
import { connect } from "react-redux";
import DynamicFormForDocumentUpload from "../../../components/dynamicscreens/DynamicFormForDocumentUpload";
import { withRouter } from "../../../components/withRouter";
import { AssetsJson } from "../../../DynamicFormsJson/MastersJSON/assets";
import { noInternetMsg, serverMsg } from "../../../config/messageconstant";
import { apiGet } from "../../../utils/api_service";
import { showLoador, showNotification } from "../../Landing/Landing.slice";

class AssetsForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            dynamicMasterData: {
            },
        };
    }


    async componentDidMount() {
        const { showLoador, showNotification } =
            this.props;
        if (navigator.onLine) {

        } else {
            showNotification({ msg: noInternetMsg, severity: "error" });
        }
    }

    getDataById = ({ id }) => {
        const { showLoador, showNotification } = this.props;
        if (navigator.onLine) {
            showLoador({ loador: true });
            const response = apiGet({
                url: AssetsJson.apiBaseURL + "/" + id,
            }).then(({ data, success }) => {
                showLoador({ loador: false });
                if (success) {
                    if (!data.error) {
                        let rowData = data.data;
                        let dataToSet = {
                            ...rowData,
                        };
                        return { response: dataToSet, success };
                    } else {
                        showNotification({ msg: serverMsg, severity: "error" });
                    }
                    return { response: {}, success: false };
                }
                return { response: {}, success: false };
            });
            return response;
        } else {
            this.props.showNotification({ msg: noInternetMsg, severity: "error" });
        }
    };
    render() {
        const { dynamicMasterData } = this.state;
        return (
            <>
                <DynamicFormForDocumentUpload
                    formPath={AssetsJson.formPath}
                    screenTitle={AssetsJson.screenTitle}
                    fieldMeta={AssetsJson.fieldMeta}
                    dynamicMasterData={dynamicMasterData}
                    apiBaseURL={AssetsJson.apiBaseURL}
                    showSaveNextBtn={AssetsJson.showSaveNextBtn}
                    callGetByIdApi={false}
                    getByIdApi={this.getDataById}
                    isEditURL={AssetsJson.isEditURL}
                />
            </>
        );
    }
}
const mapStateToProps = (state) => ({

});
const mapDispatchToProps = {
    showLoador,
    showNotification,
};
export default compose(
    withRouter,
    connect(mapStateToProps, mapDispatchToProps)
)(AssetsForm);